import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=961c1002&lang=pug&"
import script from "./Testimonial.vue?vue&type=script&lang=ts&"
export * from "./Testimonial.vue?vue&type=script&lang=ts&"
import style0 from "./Testimonial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VContainer,VDivider,VOverlay,VSheet})
